<template>
  <el-dialog title="功率曲线" :visible.sync="show" :before-close="closeDialog" width="1200px">
    <div v-loading="loading">
      <!-- 设备信息 -->
      <el-descriptions class="mb-20" title="设备信息" :column="4" border>
        <el-descriptions-item label="资产码">{{ deviceInfo.asset_code || "--" }}</el-descriptions-item>
        <el-descriptions-item label="订单编号" v-if="deviceInfo.re_dev_type != '充电桩'">{{ deviceInfo.ordernum || "--" }}</el-descriptions-item>
        <el-descriptions-item label="设备名称" v-if="deviceInfo.re_dev_type == '充电桩'">{{ deviceInfo.re_dev_name || "--" }}</el-descriptions-item>
        <el-descriptions-item label="设备类型" v-if="deviceInfo.re_dev_type == '充电桩'">{{ deviceInfo.re_dev_type || "--" }}</el-descriptions-item>
        <el-descriptions-item label="当前状态" v-if="deviceInfo.re_dev_type == '充电桩'">
          <!-- <el-tag v-if="deviceInfo.status_name === '在线'" type="success">在线</el-tag>
          <el-tag v-else-if="deviceInfo.status_name === '离线'" type="danger">离线</el-tag>
          <span v-else>--</span> -->
          <el-tag v-if="deviceInfo.status_name === '已完成'" type="success">已完成</el-tag>
          <el-tag v-else-if="deviceInfo.status_name === '己取消'" type="info">己取消</el-tag>
          <el-tag v-else type="danger">进行中</el-tag>
        </el-descriptions-item>
      </el-descriptions>

      <!-- 时间范围选择 -->
      <el-descriptions class="mb-20" title="时间范围" :column="4" border>
        <el-descriptions-item label="时间范围">
          <el-select v-model="timeRange" @change="handleTimeRangeChange" size="small" style="width: 120px">
            <el-option label="最近1小时" value="1h"></el-option>
            <el-option label="最近6小时" value="6h"></el-option>
            <el-option label="最近24小时" value="24h"></el-option>
            <el-option label="最近7天" value="7d"></el-option>
            <el-option label="最近30天" value="30d"></el-option>
            <el-option label="自定义" value="custom"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="开始时间" v-if="timeRange === 'custom'">
          <el-date-picker v-model="customStartTime" type="datetime" placeholder="选择开始时间" size="small" style="width: 190px" @change="handleCustomTimeChange"></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="结束时间" v-if="timeRange === 'custom'">
          <el-date-picker v-model="customEndTime" type="datetime" placeholder="选择结束时间" size="small" style="width: 190px" @change="handleCustomTimeChange"></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="更新时间">
          {{ lastUpdateTime || "--" }}
        </el-descriptions-item>
      </el-descriptions>

      <!-- 实时数据汇总 -->
      <el-descriptions class="mb-20" title="实时数据" :column="3" border>
        <el-descriptions-item label="电压">
          <span class="bold-text">{{ formatVoltage(realTimeData.acVolA) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="电流">
          <span class="bold-text">{{ formatCurrent(realTimeData.acCurA) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="功率">
          <span class="bold-text">{{ formatPower(realTimeData.realPower / 100) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="温度" v-if="deviceInfo.re_dev_type == '充电桩'">
          <span class="bold-text">{{ formatTemp(realTimeData.acVolB) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="总电量">
          <span class="bold-text">{{ formatTotalElectricity(realTimeData.totalElect) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="总功率">
          <span class="bold-text red-text">{{ formatPower(realTimeData.realPower / 100) }}</span>
        </el-descriptions-item>
      </el-descriptions>

      <!-- 图表展示 -->
      <el-descriptions class="mb-20 curve-chart" title="曲线图表">
        <el-descriptions-item>
          <div class="charts-container">
            <div class="chart-item">
              <div class="chart-title">电压变化曲线</div>
              <div class="chart-wrapper" ref="voltageChart"></div>
            </div>
            <div class="chart-item">
              <div class="chart-title">电流变化曲线</div>
              <div class="chart-wrapper" ref="currentChart"></div>
            </div>
            <div class="chart-item">
              <div class="chart-title">功率变化曲线</div>
              <div class="chart-wrapper" ref="powerChart"></div>
            </div>
            <div class="chart-item" v-if="deviceInfo.re_dev_type == '充电桩'">
              <div class="chart-title">温度变化曲线</div>
              <div class="chart-wrapper" ref="tempChart"></div>
            </div>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <span slot="footer">
      <el-button @click="closeDialog">关闭</el-button>
      <el-button type="primary" @click="refreshData">刷新数据</el-button>
      <el-button type="success" @click="exportData">导出数据</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as echarts from "echarts"
import { GetAcHisList } from "@/api/dev_data_view"

export default {
  name: "PowerCurve",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      timeRange: "custom",
      customStartTime: null,
      customEndTime: null,
      lastUpdateTime: "",

      deviceInfo: {},
      realTimeData: {},

      voltageChart: null,
      currentChart: null,
      powerChart: null,
      tempChart: null,

      chartData: {
        time: [],
        voltage: [],
        current: [],
        power: [],
        temperature: []
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.initDialog()
      } else {
        this.disposeCharts()
      }
    }
  },
  methods: {
    // 初始化弹窗
    initDialog() {
      console.log("kanzheli", this.params)
      this.resetData()
      this.deviceInfo = this.params

      this.loading = true
      this.fetchHistoryData()
    },

    // 重置数据
    resetData() {
      this.deviceInfo = {}
      this.realTimeData = {}
      this.chartData = {
        time: [],
        voltage: [],
        current: [],
        power: [],
        temperature: []
      }
      this.customStartTime = null
      this.customEndTime = null
      this.lastUpdateTime = ""
    },

    // 获取历史数据
    async fetchHistoryData() {
      try {
        const params = {
          assetsCode: this.params.asset_code,
          gun_no: this.params.gun_no
        }

        const { startTime, endTime } = this.calculateTimeRange()

        params.start_time = this.formatDateTimeForApi(startTime)
        params.end_time = this.formatDateTimeForApi(endTime)
        const res = await GetAcHisList(params)
        console.log(res)
        if (res.data && res.data.length > 0) {
          this.processChartData(res.data)
          this.realTimeData = res.data[res.data.length - 1]
          this.$nextTick(() => {
            this.initCharts()
          })
        } else {
          this.clearChartData()
          this.initCharts()
          this.$message.warning("此时间段内暂无数据")
        }

        this.lastUpdateTime = this.formatDateTime(new Date())
      } catch (error) {
        this.clearChartData()
      } finally {
        this.loading = false
      }
    },

    // 计算时间范围
    calculateTimeRange() {
      const now = new Date()
      let startTime = new Date()
      switch (this.timeRange) {
        case "1h":
          startTime = new Date(now.getTime() - 1 * 60 * 60 * 1000) // 1小时前
          break
        case "6h":
          startTime = new Date(now.getTime() - 6 * 60 * 60 * 1000) // 6小时前
          break
        case "24h":
          startTime = new Date(now.getTime() - 24 * 60 * 60 * 1000) // 24小时前
          break
        case "7d":
          startTime = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000) // 7天前
          break
        case "30d":
          startTime = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000) // 30天前
          break
        case "custom":
          if (this.customStartTime && this.customEndTime) {
            return {
              startTime: this.customStartTime,
              endTime: this.customEndTime
            }
          } else {
            // 默认自定义时间范围为最近1小时
            const defaultStart = new Date(now.getTime() - 1 * 60 * 60 * 1000)
            if (this.deviceInfo.charge_start_time == undefined) {
              this.customStartTime = defaultStart
              this.customEndTime = now
              this.timeRange = "24h"
            } else {
              this.customStartTime = this.deviceInfo.charge_start_time
              this.customEndTime = this.deviceInfo.charge_end_time
            }
            return {
              startTime: this.customStartTime,
              endTime: this.customEndTime
            }
          }
      }

      return { startTime, endTime: now }
    },

    // 处理图表数据
    processChartData(data) {
      this.clearChartData()

      data.forEach((item, index) => {
        const time = item.create_time || item.record_time || this.formatTimeIndex(index, data.length)
        this.chartData.time.push(time)

        // 对数据进行转换：电压除以10，电流除以100，温度除以10，功率除以100
        this.chartData.voltage.push(item.acVolA ? item.acVolA / 10 : 0)
        this.chartData.current.push(item.acCurA ? item.acCurA / 100 : 0)
        this.chartData.power.push(item.realPower ? item.realPower / 100 : 0)
        this.chartData.temperature.push(item.acVolB ? item.acVolB / 100 : 0)
      })
    },

    // 清空图表数据
    clearChartData() {
      Object.keys(this.chartData).forEach((key) => {
        this.chartData[key] = []
      })
    },

    // 初始化所有图表
    initCharts() {
      this.initChart("voltageChart", "电压(V)", ["电压"], ["voltage"], ["#5470c6"])
      this.initChart("currentChart", "电流(A)", ["电流"], ["current"], ["#91cc75"])
      this.initChart("powerChart", "功率(kW)", ["功率"], ["power"], ["#ee6666"])
      this.initChart("tempChart", "温度(°C)", ["温度"], ["temperature"], ["#fac858"])
    },

    // 初始化单个图表
    initChart(refName, yAxisName, legendData, dataKeys, colors = ["#5470c6"]) {
      if (!this.$refs[refName]) return

      if (this[refName]) {
        this[refName].dispose()
      }

      this[refName] = echarts.init(this.$refs[refName])

      const series = legendData.map((name, index) => ({
        name,
        type: "line",
        smooth: true,
        data: this.chartData[dataKeys[index]],
        lineStyle: { color: colors[index] || colors[Math.min(index, colors.length - 1)], width: 2 },
        symbol: "circle",
        symbolSize: 4
      }))

      // 根据时间范围和数据量动态设置X轴标签间隔
      const dataLength = this.chartData.time.length
      let interval = 0
      let rotate = 0

      // 根据时间范围设置不同的间隔策略
      switch (this.timeRange) {
        case "1h":
        case "6h":
        case "24h":
          // 1小时、6小时、24小时数据，大约显示8-10个标签
          if (dataLength > 12) {
            interval = Math.floor(dataLength / 8) // 大约显示8个标签
          } else if (dataLength > 6) {
            interval = 2 // 大约显示6个标签
          }
          break
        case "7d":
          // 7天数据，大约显示6-8个标签
          if (dataLength > 30) {
            interval = Math.floor(dataLength / 6) // 大约显示6个标签
          } else if (dataLength > 20) {
            interval = 4 // 大约显示7-8个标签
          } else if (dataLength > 10) {
            interval = 2 // 大约显示10个标签
          }
          break
        case "30d":
        case "custom":
          // 30天和自定义数据，大约显示4-6个标签
          if (dataLength > 50) {
            interval = Math.floor(dataLength / 5) // 大约显示5个标签
          } else if (dataLength > 30) {
            interval = 6 // 大约显示8个标签
          } else if (dataLength > 20) {
            interval = 4 // 大约显示7-8个标签
          } else if (dataLength > 10) {
            interval = 2 // 大约显示10个标签
          }
          break
      }

      const option = {
        tooltip: {
          trigger: "axis",
          confine: true,
          formatter: (params) => {
            let result = params[0].name + "<br/>"
            params.forEach((item) => {
              const unit = this.getUnitByChartType(refName, item.seriesName)
              result += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${item.color}"></span>`
              result += `${item.seriesName}: ${item.value} ${unit}<br/>`
            })
            return result
          }
        },
        legend: {
          data: legendData,
          top: 13,
          right: 20,
          itemWidth: 12,
          itemHeight: 12
        },
        grid: {
          left: "4%",
          right: "4%",
          bottom: "9%", // 增加底部间距，为旋转的标签腾出空间
          top: "16%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.chartData.time,
          axisLabel: {
            rotate: rotate,
            interval: interval,
            margin: 10,
            padding: [10, 0, 0, 0],
            formatter: (value) => {
              if (!value) return ""

              // 尝试解析各种时间格式
              let dateObj = null
              if (value.includes(" ") || value.includes("T") || value.includes("-")) {
                dateObj = new Date(value)
              } else if (value.includes(":")) {
                // 可能是只有时间的情况
                const now = new Date()
                const [hours, minutes] = value.split(":")
                dateObj = new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(hours), parseInt(minutes || 0))
              }

              if (dateObj && !isNaN(dateObj.getTime())) {
                const year = dateObj.getFullYear()
                const month = (dateObj.getMonth() + 1).toString().padStart(2, "0")
                const day = dateObj.getDate().toString().padStart(2, "0")
                const hours = dateObj.getHours().toString().padStart(2, "0")
                const minutes = dateObj.getMinutes().toString().padStart(2, "0")

                switch (this.timeRange) {
                  case "1h":
                  case "6h":
                  case "24h":
                    // 1小时、6小时、24小时视图：显示月-日 时:分
                    return `${month}-${day} ${hours}:${minutes}`
                  case "7d":
                    // 7天视图：显示月-日
                    return `${month}-${day}`
                  case "30d":
                  case "custom":
                    // 30天和自定义：显示年-月-日
                    return `${year}-${month}-${day}`
                  default:
                    return `${year}-${month}-${day} ${hours}:${minutes}`
                }
              }

              return value
            }
          },
          axisTick: {
            alignWithLabel: true,
            length: 5
          },
          axisLine: {
            lineStyle: {
              color: "#ccc"
            }
          },
          nameTextStyle: {
            padding: [10, 0, 0, 0]
          }
        },
        yAxis: {
          type: "value",
          name: yAxisName,
          min: 0,
          axisLine: {
            lineStyle: {
              color: "#ccc"
            }
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#eee"
            }
          }
        },
        series
      }

      this[refName].setOption(option)
    },

    // 根据图表类型获取单位
    getUnitByChartType(chartType, seriesName) {
      switch (chartType) {
        case "voltageChart":
          return "V"
        case "currentChart":
          return "A"
        case "powerChart":
          return "kW"
        case "tempChart":
          return "°C"
        default:
          return ""
      }
    },

    // 销毁图表
    disposeCharts() {
      ;[this.voltageChart, this.currentChart, this.powerChart, this.tempChart].forEach((chart) => {
        if (chart) chart.dispose()
      })
    },

    // 处理时间范围变化
    handleTimeRangeChange() {
      if (this.timeRange === "custom") {
        // 如果没有设置自定义时间，则设置默认值为当前时间前1小时到当前时间
        if (!this.customStartTime || !this.customEndTime) {
          const now = new Date()
          this.customStartTime = new Date(now.getTime() - 1 * 60 * 60 * 1000)
          this.customEndTime = now
        }
        this.fetchHistoryData()
      } else {
        this.fetchHistoryData()
      }
    },

    // 处理自定义时间变化
    handleCustomTimeChange() {
      if (this.timeRange === "custom" && this.customStartTime && this.customEndTime) {
        if (this.customStartTime > this.customEndTime) {
          this.$message.warning("开始时间不能晚于结束时间")
          this.customEndTime = null
          return
        }
        this.fetchHistoryData()
      }
    },

    // 刷新数据
    refreshData() {
      this.fetchHistoryData()
      this.$message.success("数据已刷新")
    },

    // 导出数据
    exportData() {
      const exportData = {
        设备信息: this.deviceInfo,
        实时数据: this.realTimeData,
        图表数据: this.chartData,
        导出时间: this.formatDateTime(new Date())
      }

      const dataStr = JSON.stringify(exportData, null, 2)
      const dataUri = "data:application/json;charset=utf-8," + encodeURIComponent(dataStr)
      const exportFileName = `功率曲线_${this.deviceInfo.asset_code || "data"}_${new Date().getTime()}.json`

      const linkElement = document.createElement("a")
      linkElement.setAttribute("href", dataUri)
      linkElement.setAttribute("download", exportFileName)
      document.body.appendChild(linkElement)
      linkElement.click()
      document.body.removeChild(linkElement)

      this.$message.success("数据导出成功")
    },

    // 格式化电压 - 除以10
    formatVoltage(value) {
      if (value === undefined || value === null) return "-- V"
      return `${(Number(value) / 10).toFixed(1)} V`
    },

    // 格式化电流 - 除以100
    formatCurrent(value) {
      if (value === undefined || value === null) return "-- A"
      return `${(Number(value) / 100).toFixed(1)} A`
    },

    // 格式化功率
    formatPower(value) {
      if (value === undefined || value === null) return "-- kW"
      return `${Number(value).toFixed(2)} kW`
    },

    // 格式化温度 - 除以10
    formatTemp(value) {
      if (value === undefined || value === null) return "-- °C"
      return `${(Number(value) / 100).toFixed(1)} °C`
    },

    // 格式化总电量
    formatTotalElectricity(value) {
      if (value === undefined || value === null) return "-- kWh"
      const numValue = Number(value)
      if (isNaN(numValue)) return "-- kWh"
      return `${(numValue / 1000).toFixed(2)} kWh`
    },

    // 格式化日期时间
    formatDateTime(date) {
      if (!date) return ""
      const d = new Date(date)
      const year = d.getFullYear()
      const month = (d.getMonth() + 1).toString().padStart(2, "0")
      const day = d.getDate().toString().padStart(2, "0")
      const hours = d.getHours().toString().padStart(2, "0")
      const minutes = d.getMinutes().toString().padStart(2, "0")
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },

    // 格式化API时间格式
    formatDateTimeForApi(date) {
      if (!date) return ""
      const d = new Date(date)
      const year = d.getFullYear()
      const month = (d.getMonth() + 1).toString().padStart(2, "0")
      const day = d.getDate().toString().padStart(2, "0")
      const hours = d.getHours().toString().padStart(2, "0")
      const minutes = d.getMinutes().toString().padStart(2, "0")
      const seconds = d.getSeconds().toString().padStart(2, "0")
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 格式化时间索引
    formatTimeIndex(index, total) {
      const now = new Date()
      let interval

      if (this.timeRange === "1h" || this.timeRange === "6h" || this.timeRange === "24h") {
        interval = 3600000
      } else {
        interval = (24 * 3600000) / total
      }

      const time = new Date(now.getTime() - (total - index - 1) * interval)
      const year = time.getFullYear()
      const month = (time.getMonth() + 1).toString().padStart(2, "0")
      const day = time.getDate().toString().padStart(2, "0")
      const hours = time.getHours().toString().padStart(2, "0")
      const minutes = time.getMinutes().toString().padStart(2, "0")

      if (this.timeRange === "1h" || this.timeRange === "6h" || this.timeRange === "24h") {
        return `${year}-${month}-${day} ${hours}:${minutes}`
      } else {
        return `${year}-${month}-${day} ${hours}:00`
      }
    },

    // 关闭弹窗
    closeDialog() {
      this.disposeCharts()
      this.resetData()
      this.$emit("update:show", false)
    }
  },
  beforeDestroy() {
    this.disposeCharts()
  }
}
</script>

<style scoped lang="scss">
.mb-20 {
  margin-bottom: 20px;
}

.bold-text {
  font-weight: bold;
  font-size: 16px;
}

.red-text {
  color: #f56c6c;
}

.charts-container {
  display: grid;
  width: 100%;
  gap: 20px;
  margin-top: 10px;
}

.curve-chart ::v-deep .el-descriptions__title::after {
  content: none !important;
}

.curve-chart ::v-deep .el-descriptions-item__label::after {
  content: "" !important;
}

.chart-item {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.chart-title {
  padding: 12px 20px;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.chart-wrapper {
  height: 280px;
  width: 100%;
}
</style>
